export class BaseGraphQL {
    constructor(client) {
        this._client = client;
    }
}
export * from './did.js';
